<div class="sb-step sb-step-address">
  <form class="sb-step__form" [formGroup]="formGroup">
    <div class="sb-step__form__content">
      <div class="sb-step__inner-container">
        <!-- <sb-promo-banner></sb-promo-banner> -->
        <!-- region Delivery address -->
        <ng-container *ngIf="simType === SimTypes.Standard">
          <div class="sb-form-block wt-margin-top-4">
            <div class="sb-form-block__title">
              {{'ENTITY.DELIVERY-ADDRESS.TITLE' | translate}}
            </div>
            <sb-form-address formGroupName="customerDeliveryAddress"></sb-form-address>
            <sb-box-info [iconType]="['icon-envelope-running-green']" [infoText]="'ENTITY.DELIVERY-ADDRESS.INFO' | translate"></sb-box-info>
            <!-- endregion -->
            <div class="sb-step-address__address-check" [formGroup]="inferredAddressForm">
              <wt-input-checkbox (clicked)="onCheckAddressClick()" formControlName="residenceAsDelivery">
                <div class="wt-text-base-l sb-address-check" [innerHTML]="'ENTITY.DELIVERY-ADDRESS.DELIVERY-AS-RESIDENCE' | translate"></div>
              </wt-input-checkbox>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="shouldShowDeliveryAddress">
          <div class="sb-form-block" @fadeAnimation>
            <div class="sb-form-block__title">
              {{'ENTITY.RESIDENCE-ADDRESS.TITLE' | translate}}
            </div>
            <sb-form-address formGroupName="customerResidenceAddress" [countriesAutocompleteInputOptions]="availableCountries"></sb-form-address>
          </div>
        </ng-container>
      </div>
    </div>
    <div class="sb-step__form__footer">
      <sb-navigation-buttons [isSticky]="shouldBeSticky" [submitDisabled]="this.formGroup.invalid" (backClick)="goToPreviousStep()" (submitClick)="goToNextStep()"></sb-navigation-buttons>
    </div>
  </form>
</div>
